<template>
  <div class="main">
    <section class="light-content">
      <div class="container">
        <div class="text text-primary">
          <text-lang :lang="lang">
            <template slot="es">Invertimos capital y financiamos empresas en Venezuela</template>
            <template slot="en">We invest capital and finance companies in Venezuela</template>
          </text-lang>
        </div>
      </div>
    </section>

    <section class="light-content">
      <div class="container">
        <list-content class="list-content-secondary">
          <list-content-item>
            <p class="title-content title-content-quaternary">
              <text-lang :lang="lang">
                <template slot="es">¿Necesita capital para hacer crecer su empresa?</template>
                <template slot="en">Does your company need capital to grow?</template>
              </text-lang>
            </p>
            <p class="text text-secondary">
              <text-lang :lang="lang">
                <template slot="es">Con Inversiones CrecePymes puede obtener el capital para expandir su empresa, ampliar la capacidad productiva o adquirir otras empresas para crecer. Haga que su empresa sea más rentable y productiva y hágala crecer en menos tiempo.</template>
                <template slot="en">Our firm obtains and injects the capital necessary to expand and grow your business, enhance productivity and/or acquire other companies to grow. Allow your company to improve profitability  and productivity and make it grow in faster.</template>
              </text-lang>
            </p>
          </list-content-item>

          <list-content-item>
            <p class="title-content title-content-quaternary">
              <text-lang :lang="lang">
                <template slot="es">¿Quiere vender su empresa?</template>
                <template slot="en">Do you want to sell your company?</template>
              </text-lang>
            </p>
            <p class="text text-secondary">
              <text-lang :lang="lang">
                <template slot="es">Inversiones CrecePymes, inscrita en la Bolsa de Valores de Caracas, puede invertir en acciones de su empresa para hacerla perdurar y crecer. Reciba capital de Inversiones CrecePymes, capitalice su esfuerzo de tantos años y permita que su empresa crezca.</template>
                <template slot="en">CrecePymes, trading on the Caracas Stock Exchange, can invest and fully or partially acquire your company to make it grow. Get access to the capital your company needs to expand and capitalize on that growth.</template>
              </text-lang>
            </p>
          </list-content-item>

          <list-content-item>
            <p class="title-content title-content-quaternary">
              <text-lang :lang="lang">
                <template slot="es">¿Quiere refinanciar su empresa?</template>
                <template slot="en">Do you want to refinance or restructure your company?</template>
              </text-lang>
            </p>
            <p class="text text-secondary">
              <text-lang :lang="lang">
                <template slot="es">Inversiones CrecePymes le ofrece el capital para reducir deudas y bajar los altos costos financieros de su empresa.</template>
                <template slot="en">Our firm offers capital to reduce your company's debt and high financing costs.</template>
              </text-lang>
            </p>
          </list-content-item>
        </list-content>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import ListContent from '@/components/ListContent.vue'
import ListContentItem from '@/components/ListContentItem.vue'
import TextLang from '@/components/TextLang.vue'

export default {
  name: 'Home',
  props: ['lang'],
  components: {
    Parallax,
    ListContent,
    ListContentItem,
    TextLang
  }
}
</script>
